// extracted by mini-css-extract-plugin
export default {"unorderedList":"styles_unorderedList__FlHyN","listItem":"styles_listItem__Jnmy4","strong":"styles_strong__Ijhi7","specs":"styles_specs__APfeV"};